<template>
    <div class="card"  @click="checkDetial">
        <div class="status">{{getProjectContractName(item.type)}}</div>
        <div class="tag" :style="'background:'+color"></div>
         <div class="card-title">{{item.name}}</div>
         <div class="card-partnerName" >{{item.partnerName}}</div>
        <div class="importance">
            <div class="card-content">签订日期：{{dayjs(item.signTime).format('YYYY-MM-DD')}}</div>
            <div class="card-content">合同金额：{{tool.money_format_allowvoid(item.money)}}</div>
        </div>
        
    </div>
</template>

<script>
export default {
    props:{
        color:'',
        detial:{
            default:'aaa'
        },
        item:{},
        projectContractTypeList:[],//合同字典类型
    },
    data(){
        return {
            width:'',
            height:'',
        }
    },
    watch: {
      '$store.state.windowSize.screenWidth': function (val) { //监听屏幕宽度变化
          console.log("屏幕的宽度",val)
          this.width = val/10;
          this.$forceUpdate()
      },
      '$store.state.windowSize.screenHeight': function (val) { //监听屏幕高度变化
          console.log("屏幕的高度",val)
          this.height = val/10;
          this.$forceUpdate()
        }
    },
    created(){
        this.width =  document.documentElement.clientWidth/10; 
        this.height =document.documentElement.clientHeight/10;
    },
    methods:{
        checkDetial(){
            console.log("grandson",this.item)
            this.item.color = this.color;
            this.$emit("getDetail",this.item)
        },
        getProjectContractName(dictKey) {
        if(this.projectContractTypeList.length>0){
            let ProjectContractName = '';
            this.projectContractTypeList.forEach((element) => {
                if (element.dictKey == dictKey) {
                ProjectContractName = element.dictValue+'';
                }
            });
            return ProjectContractName.replace(/合同?$/g,'').slice(0,8);
        }
        },
    }
};
</script>

<style scoped>
.card-partnerName{
  display: flex;
  flex-wrap: wrap;
  /* height: 18px; */
  font-size: 14px;
  
  font-weight: 400;
  line-height: 18px;
  color: #606266;
  margin-bottom:8px;
  word-break: break-all 
}
.importance {
  display: grid;
  grid-template-rows:  18px 18px;
  grid-row-gap: 8px;
}
.tag {
  width: 4px;
  height: 24px;
  background: #2e8b78;
  left: 0;
  top: 0;
  position: absolute;
}
.status {
  /* width: 20px; */
  width: 10px;
  line-height: 16px;
  background-color: rgba(249, 157, 53, 0.1);
  /* height: 34px; */
  border-radius: 0px 0px 10px 10px;
  position: absolute;
  right: 12px;
  top: 0;
  font-size: 10px;
  padding: 5px 5px;
  font-weight: 400;
  display: flex;
  /* align-items: center;
        justify-content: center; */
  text-align: center;
  flex-wrap: wrap;
  color: #f99d35;
}
.card {
  width: 100%;
  min-width: 328px;
  background: #ffffff;
  padding: 16px;
  padding-right: 40px;
  box-sizing: border-box;
  position: relative;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
.card-title {
    display: flex;
    flex-wrap: wrap;
  /* height: 18px; */
  font-size: 14px;

  font-weight: bold;
  margin-bottom: 8px;
  /* line-height: 18px; */
  color: #303133;
}
.card-content {
  height: 18px;
  font-size: 14px;

  font-weight: 400;
  line-height: 18px;
  color: #606266;
}
</style>
